import React from "react";
import LoginPanel from "@/components/dashboard/LoginPanel";
import ComingSoon from "@/components/dashboard/ComingSoon";
import { useUnlock } from "@/pages/Dashboard";
import { usePrice } from "@/lib/price";

export { LoginPanel, ComingSoon };

/**
 * PaidRoute — block an All-Access-only dashboard page for free users.
 * Renders the standard UnlockModal trigger inline (read from context).
 * Price + scarcity copy come from /api/price via usePrice().
 */
export function PaidRoute({ tool, children }) {
  const ctx = useUnlock();
  const { price, remaining, cap } = usePrice();
  if (ctx?.paid) return children;
  return (
    <section data-testid="paid-gate" className="max-w-3xl">
      <div className="bg-[#FFC400] border-4 border-[#0a0a0a] shadow-brutal p-7 md:p-9">
        <div className="font-accent text-xs bg-[#0a0a0a] text-[#FFC400] inline-block px-2.5 py-1 mb-4">
          ALL-ACCESS ONLY
        </div>
        <h2 className="font-display text-3xl md:text-4xl leading-[0.95]">
          {tool} is locked.{" "}
          <span className="bg-[#0a0a0a] text-[#FFC400] px-2">Unlock for {price}.</span>
        </h2>
        <p className="font-mono-body text-sm md:text-base mt-3 text-[#0a0a0a]/80">
          One-time, lifetime. Same membership unlocks every other tool too.
        </p>
        {remaining && cap && (
          <p
            data-testid="paid-gate-scarcity"
            className="font-mono-body text-xs mt-2 text-[#0a0a0a]/75"
          >
            <b className="text-[#E10600]">{remaining.toLocaleString()}</b> of {cap.toLocaleString()} launch spots left at <b>{price}</b>.
          </p>
        )}
        <button
          type="button"
          onClick={() => ctx.open(tool)}
          data-testid="paid-gate-cta"
          className="hover-pop mt-6 inline-flex items-center gap-2 bg-[#0a0a0a] text-[#FFC400] border-4 border-[#0a0a0a] px-5 py-3 font-accent text-sm shadow-brutal"
        >
          See what unlocks →
        </button>
      </div>
    </section>
  );
}

export { LoginPanel as default };
